import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

/**
 * 2026-ready Footer
 * - Glassmorphism
 * - Mobile-first
 * - Clean design tokens
 * - Matches modern navbar
 */

const COLORS = {
  bg: 'rgba(11, 15, 25, 0.88)',
  border: 'rgba(255, 255, 255, 0.08)',
  accent: '#4f8cff',
  text: '#ffffff',
  muted: '#9aa4bf',
};

const Footer = () => {
  return (
    <footer
      style={{
        background: COLORS.bg,
        backdropFilter: 'blur(14px)',
        borderTop: `1px solid ${COLORS.border}`,
        color: COLORS.text,
        marginTop: 'auto',
      }}
    >
      <Container className="pt-5 pb-4">
        <Row className="gy-4">

          {/* BRAND */}
          <Col md={4}>
            <h4 style={{ fontWeight: 800, letterSpacing: '0.4px' }}>
              🛒 MyIdea<span style={{ color: COLORS.accent }}>Shop</span>
            </h4>
            <p style={{ color: COLORS.muted, maxWidth: 320 }}>
              Discover top-quality products and enjoy a seamless, modern shopping experience.
            </p>
          </Col>

          {/* SHOP */}
          <Col xs={6} md={2}>
            <h6 style={headingStyle}>Shop</h6>
            <ul style={listStyle}>
              <li><a href="/shop" style={linkStyle}>All Products</a></li>
              <li><a href="/deals" style={linkStyle}>Deals</a></li>
              <li><a href="/categories" style={linkStyle}>Categories</a></li>
              <li><a href="/wishlist" style={linkStyle}>Wishlist</a></li>
            </ul>
          </Col>

          {/* SUPPORT */}
          <Col xs={6} md={2}>
            <h6 style={headingStyle}>Support</h6>
            <ul style={listStyle}>
              <li><a href="/contact" style={linkStyle}>Contact</a></li>
              <li><a href="/faq" style={linkStyle}>FAQs</a></li>
              <li><a href="/shipping" style={linkStyle}>Shipping</a></li>
              <li><a href="/returns" style={linkStyle}>Returns</a></li>
            </ul>
          </Col>

          {/* NEWSLETTER */}
          <Col md={4}>
            <h6 style={headingStyle}>Stay in the loop</h6>

            <Form className="d-flex flex-column flex-sm-row gap-2">
              <Form.Control
                type="email"
                placeholder="Enter your email"
                aria-label="Email address"
                style={{
                  background: 'rgba(255,255,255,0.06)',
                  border: `1px solid ${COLORS.border}`,
                  color: COLORS.text,
                  borderRadius: '999px',
                }}
              />
              <Button
                style={{
                  background: COLORS.accent,
                  border: 'none',
                  borderRadius: '999px',
                  padding: '0.45rem 1.25rem',
                  fontWeight: 600,
                }}
              >
                Subscribe
              </Button>
            </Form>

            <small style={{ color: COLORS.muted, display: 'block', marginTop: '0.5rem' }}>
              No spam. Just product drops & offers.
            </small>
          </Col>
        </Row>

        {/* DIVIDER */}
        <hr style={{ borderColor: COLORS.border, margin: '2.5rem 0 1.5rem' }} />

        {/* BOTTOM */}
        <Row className="align-items-center gy-3">
          <Col md={6} className="text-center text-md-start">
            <small style={{ color: COLORS.muted }}>
              © {new Date().getFullYear()} MyIdeaShop. All rights reserved.
            </small>
          </Col>

          <Col md={6} className="text-center text-md-end">
            <SocialIcon icon={<FaFacebookF />} />
            <SocialIcon icon={<FaTwitter />} />
            <SocialIcon icon={<FaInstagram />} />
            <SocialIcon icon={<FaYoutube />} />
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

/* ---------- Small Components ---------- */

const SocialIcon = ({ icon }) => (
  <a
    href="#"
    style={{
      color: COLORS.text,
      marginLeft: '1rem',
      fontSize: '1rem',
      opacity: 0.8,
      transition: 'opacity 0.2s ease',
    }}
    onMouseEnter={e => (e.currentTarget.style.opacity = 1)}
    onMouseLeave={e => (e.currentTarget.style.opacity = 0.8)}
  >
    {icon}
  </a>
);

/* ---------- Styles ---------- */

const headingStyle = {
  textTransform: 'uppercase',
  fontWeight: 700,
  fontSize: '0.75rem',
  letterSpacing: '0.08em',
  marginBottom: '1rem',
  color: COLORS.text,
};

const listStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
};

const linkStyle = {
  color: COLORS.muted,
  textDecoration: 'none',
  display: 'block',
  marginBottom: '0.5rem',
  fontSize: '0.9rem',
};

export default Footer;
